import { Icon, Menu } from "@blueprintjs/core";
import { MenuItem2 } from "@blueprintjs/popover2";
import React from "react";

import { HockeyActionLineType } from "../../types";
import { ActionLineProps, DottedLine, Shoot, SkateBackwards, SolidLine, SquiggleLine } from "../action-lines";
import { ActionSvgContainer } from "./action-svg-container";
import styles from "./select-action-menu.module.scss";

const actionLineProps: ActionLineProps = {
  action: { pos: { x: 0, y: 25 }, midPoints: [], endPos: { x: 47, y: 25 }, color: "#fff" },
  strokeWidth: 2,
  animateable: false,
};

interface HockeySelectActionMenuProps {
  handleClickAction: (action: { layerType: HockeyActionLineType }) => void;
  handleCancel?: () => void;
}

export const HockeySelectActionMenu = ({ handleClickAction, handleCancel }: HockeySelectActionMenuProps) => {
  return (
    <div className="bp4-dark">
      <Menu className={styles.changeActionMenu}>
        <MenuItem2
          text={
            <ActionSvgContainer label="Skate">
              <SolidLine {...actionLineProps} />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: HockeyActionLineType.SKATE })}
        />
        <MenuItem2
          text={
            <ActionSvgContainer label="Skate Backwards">
              <SkateBackwards {...actionLineProps} />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: HockeyActionLineType.SKATE_BACKWARDS })}
        />
        <MenuItem2
          text={
            <ActionSvgContainer label="Pass">
              <DottedLine {...actionLineProps} />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: HockeyActionLineType.PASS })}
        />
        <MenuItem2
          text={
            <ActionSvgContainer label="Shoot">
              <Shoot
                {...actionLineProps}
                action={{ ...actionLineProps.action, endPos: { x: 43, y: 25 } }}
                coverColor="#000"
              />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: HockeyActionLineType.SHOOT })}
        />
        <MenuItem2
          text={
            <ActionSvgContainer label="Skate w/ Puck">
              <SquiggleLine {...actionLineProps} />
            </ActionSvgContainer>
          }
          onClick={() => handleClickAction({ layerType: HockeyActionLineType.SKATE_WITH_PUCK })}
        />
        {handleCancel && (
          <MenuItem2 text={<Icon role="button" icon="cross" color="#fff" size={24} />} onClick={handleCancel} />
        )}
      </Menu>
    </div>
  );
};
